import React from "react";
import "./DownloadSection.css";

const DownloadSection = () => {
  return (
    <section id="telecharger" className="section section--light">
      <div className="container">
        <div className="download__content text-center">
          <div className="download__header animate-fade-in-up">
            <h2 className="download__title">Téléchargez Chiesugu Maintenant</h2>
            <p className="download__subtitle">
              Rejoignez la communauté d'éleveurs et d'acheteurs qui transforment
              le marché avicole malien. Disponible sur toutes les plateformes.
            </p>
          </div>

          <div className="download__cards">
            <div className="download__card card animate-fade-in-up">
              <div className="download__card-icon">📱</div>
              <h3 className="download__card-title">Application Mobile</h3>
              <p className="download__card-description">
                Application Flutter native pour iOS et Android avec des
                performances optimisées et une interface utilisateur moderne.
              </p>
              <div className="download__buttons">
                <a
                  target="_blank"
                  href="https://apps.apple.com/app/chiesugu/id6752285751"
                  className="btn btn--primary download__btn"
                >
                  <span className="download__btn-icon">🍎</span>
                  App Store
                </a>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.djammadev.chiesugu"
                  className="btn btn--primary download__btn"
                >
                  <span className="download__btn-icon">🤖</span>
                  Google Play
                </a>
              </div>
            </div>

            <div className="download__card card animate-fade-in-up">
              <div className="download__card-icon">🌐</div>
              <h3 className="download__card-title">Version Web</h3>
              <p className="download__card-description">
                Accédez à Chiesugu directement depuis votre navigateur web.
                Interface responsive et fonctionnalités complètes.
              </p>
              <div className="download__buttons">
                <a href="/web" className="btn btn--secondary download__btn">
                  <span className="download__btn-icon">💻</span>
                  Accéder au Web
                </a>
              </div>
            </div>
          </div>

          <div className="download__stats animate-fade-in-up">
            <div className="download__stat">
              <div className="download__stat-number">500+</div>
              <div className="download__stat-label">Utilisateurs actifs</div>
            </div>
            <div className="download__stat">
              <div className="download__stat-number">1000+</div>
              <div className="download__stat-label">Produits vendus</div>
            </div>
            <div className="download__stat">
              <div className="download__stat-number">4.8★</div>
              <div className="download__stat-label">Note moyenne</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
